export default class LessonPlansService {
  constructor(http) {
    this.http = http;
  }

  // 수업계획서 목록 조회
  async findAll(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/lessonplans/readall?${queryParams}`, {
      method: "GET",
    });
  }

  // 특정 수업의 계획서 조회 (lesson_id로)
  async findByLessonId(lessonId, conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(
      `/api/lessonplans/by-lesson/${lessonId}?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  // 수업계획서 생성
  async createLessonPlan(data) {
    return this.http.fetch(`/api/lessonplans/create`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  // 수업계획서 Upsert (생성 또는 수정 - lesson_id 기준)
  async upsertLessonPlan(data) {
    return this.http.fetch(`/api/lessonplans/upsert`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  // 수업계획서 수정
  async updateLessonPlan(id, data) {
    return this.http.fetch(`/api/lessonplans/update/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  // 수업계획서 삭제
  async deleteLessonPlan(id) {
    return this.http.fetch(`/api/lessonplans/delete/${id}`, {
      method: "DELETE",
    });
  }

  // 샘플 목록 조회
  async findSamples(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/lessonplans/samples?${queryParams}`, {
      method: "GET",
    });
  }

  // 샘플 Upsert (is_sample: true, 학년도/학기당 1개만 유지)
  async upsertSample(data) {
    return this.http.fetch(`/api/lessonplans/upsert`, {
      method: "POST",
      body: JSON.stringify({ ...data, is_sample: true }),
    });
  }
}
